import { useCallback, useEffect, useState } from 'react'

import { getRandomAffirmations } from 'sanity'

import type { AffirmationData, AffirmationType } from './AffirmationData'

export default function useRandomAffirmationsData(
  numberOfAffirmations: number,
  types: AffirmationType[],
) {
  const [affirmations, setAffirmations] = useState<AffirmationData[] | null>(null)
  const [refreshCount, setRefreshCount] = useState(0)

  const refresh = useCallback(() => {
    setRefreshCount((c) => c + 1)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      setAffirmations(null)
      const data = await fetchAffirmations(numberOfAffirmations, types)
      setAffirmations(data)
    }
    fetchData()
  }, [refreshCount, numberOfAffirmations, types])

  return { affirmations, refresh }
}

async function fetchAffirmations(
  count: number,
  types: AffirmationType[],
): Promise<AffirmationData[] | null> {
  try {
    const fetched = await getRandomAffirmations(count, types)
    if (Array.isArray(fetched)) {
      return fetched
        .filter((item) => item && typeof item.text === 'string')
        .map((item) => ({ text: item.text as string }))
    }
  } catch (error) {
    console.error('Failed to fetch affirmations:', error)
  }
  return null
}
